import { normalize } from "normalizr";
import { calendarEvent } from "~/schemas/schema.calendarEvents";
import { discussion } from "~/schemas/schema.discussions";
import { note } from "~/schemas/schema.notes";
import { task } from "~/schemas/schema.tasks";
import {
  ADD_COMMENT_FROM_EVENT_STREAM_SUCCESS,
  APPEND_TO_PARENT_SUCCESS,
  EDIT_CALENDAR_EVENT_SUCCESS,
  EDIT_DISCUSSION_SUCCESS,
  EDIT_NOTE_SUCCESS,
  EDIT_TASK_SUCCESS,
  UPDATE_COMMENT_FROM_EVENT_STREAM_SUCCESS,
} from "~/store/action_types";
import { prefetchCalendarEvent } from "../actions/actions.calendarEvents";
import { getCalendarByEventId } from "../selectors/selector.calendarEvents";

const commentsMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const { type, response } = action;

    switch (type) {
      case APPEND_TO_PARENT_SUCCESS: {
        if (response) {
          const { single = {} } = response;
          let normalized;
          let type;
          switch (single.class) {
            case "Task":
              normalized = normalize(response, {
                single: task,
              });
              type = EDIT_TASK_SUCCESS;
              break;
            case "Discussion":
              normalized = normalize(response, {
                single: discussion,
              });
              type = EDIT_DISCUSSION_SUCCESS;
              break;
            case "Note":
              normalized = normalize(response, {
                single: note,
              });
              type = EDIT_NOTE_SUCCESS;
              break;
            case "CalendarEvent":
              normalized = normalize(response, {
                single: calendarEvent,
              });
              type = EDIT_CALENDAR_EVENT_SUCCESS;
              break;
          }
          if (normalized && type) {
            dispatch({
              type: type,
              response: normalized,
            });
          }
        }

        return next(action);
      }
      case ADD_COMMENT_FROM_EVENT_STREAM_SUCCESS:
      case UPDATE_COMMENT_FROM_EVENT_STREAM_SUCCESS: {
        if (action.parentType === "CalendarEvent") {
          const calendar = getCalendarByEventId(getState(), action.parentId);
          if (calendar) {
            return dispatch(prefetchCalendarEvent(calendar.id, action.parentId)).then(() => {
              return next(action);
            });
          }
        }
        return next(action);
      }
      default:
        return next(action);
    }
  };

export default commentsMiddleware;
